import { useSelector } from "react-redux";

/** @type {import("react-redux").UseSelector<AppRootState>} */
const useZeroSelector = useSelector;

export default useZeroSelector;